export function getStoredKey (name: string): string {
  return `abtest-${name}`
}
